import { useIsMutating } from "@tanstack/react-query";
import { Loader } from "lucide-react";
import { FC } from "react";
import { useParams } from "react-router";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useDialogState } from "@/hooks/use-dialog-state";

type Props = {
  onDelete: () => void;
};

export const DeletePlaylistTrackDialog: FC<Props> = ({ onDelete }) => {
  const { dialog, closeDialog } = useDialogState();
  const { skuId } = useParams<{ skuId: string }>();
  const isDeleting = useIsMutating({
    mutationKey: ["skus", "update", skuId],
  });

  return (
    <AlertDialog open={dialog?.name === "delete-playlist-track"}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Track</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this track?{" "}
            <i className="text-black">
              This action is irreversible and the track cannot be recovered.
            </i>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button
            variant="outline"
            onClick={closeDialog}
            disabled={isDeleting > 0}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={isDeleting > 0}
          >
            {isDeleting > 0 ? <Loader className="animate-spin" /> : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
